import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid, Paper, Typography } from "@material-ui/core";

const siteColor1 = (window as any).APP_CONFIG ? (window as any).APP_CONFIG.siteColor1 : "#fd6422";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 40,
    paddingBottom: 60,
  },
  title: {
    textAlign: "center",
    fontWeight: 600,
    color: "#444",
  },
  content: {
    textAlign: "center",
    marginTop: 10,
    color: "#666",
  },
  grid: {
    marginTop: 20,
  },
  groupLink: {
    display: "block",
    textDecoration: "none",
    color: "inherit",
  },
  groupCard: {
    overflow: "hidden",
    border: "solid 1px rgb(238,238,238)",
    transition: "box-shadow .2s ease, border-color .2s ease",
    "&:hover": {
      borderColor: siteColor1,
      boxShadow: "0px 4px 16px rgba(0,0,0,.15)",
    },
  },
  // fixed 4:3 box (padding-top trick), so common image sizes drop straight in
  groupImageContainer: {
    position: "relative",
    width: "100%",
    paddingTop: "75%",
    backgroundColor: "#f5f5f5",
  },
  groupImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // contain, so admin-uploaded product renders are never cropped
    objectFit: "contain",
  },
  groupTextContainer: {
    padding: 15,
    textAlign: "center",
  },
  groupName: {
    fontWeight: 600,
    color: "#444",
  },
  groupDescription: {
    marginTop: 5,
    color: "#888",
  },
}));

export default (props: { siteSetting: SiteSetting; groups: TemplateGroup[] }) => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.root}>
      {!!props.siteSetting.landing_page_title && (
        <Typography variant="h4" component="h1" className={classes.title}>
          {props.siteSetting.landing_page_title}
        </Typography>
      )}
      {!!props.siteSetting.landing_page_content && (
        <div className={classes.content} dangerouslySetInnerHTML={{ __html: props.siteSetting.landing_page_content }} />
      )}

      <Grid container spacing={3} justify="center" className={classes.grid}>
        {props.groups.map((group) => (
          <Grid item xs={12} sm={6} md={4} key={group.slug}>
            <a href={`/${group.slug}/`} className={classes.groupLink}>
              <Paper elevation={0} className={classes.groupCard}>
                <div className={classes.groupImageContainer}>
                  {!!group.image && <img src={group.image} alt={group.name} className={classes.groupImage} />}
                </div>
                {(!group.hide_label_in_landing_page || !!group.description) && (
                  <div className={classes.groupTextContainer}>
                    {!group.hide_label_in_landing_page && (
                      <Typography variant="h6" className={classes.groupName}>
                        {group.name}
                      </Typography>
                    )}
                    {!!group.description && (
                      <Typography variant="body2" className={classes.groupDescription}>
                        {group.description}
                      </Typography>
                    )}
                  </div>
                )}
              </Paper>
            </a>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
